"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const clientAppOnAuthenticated_1 = __importDefault(require("../clientAppOnAuthenticated"));
const buildLoginWithFacebook = (args) => async ({ functionId, callbacks, executeProcesses, processor, store, }) => {
    try {
        const state = store.getState();
        const projectId = (0, appStateSelectProjectId_1.default)(state);
        const appId = (0, appStateSelectAppId_1.default)(state);
        await args.localLoginWithFacebook({ appId });
        await (0, clientAppOnAuthenticated_1.default)({
            appId,
            processor,
            projectId,
        });
        if (processor.root.isInDevelopment && args.onUserLoggedInDevelopment) {
            await args.onUserLoggedInDevelopment({ appId });
        }
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (error) {
        if (!(0, valueIsRecord_1.default)(error)) {
            executeProcesses(functionId, callbacks.errorProcess, 'Unknown error');
            return;
        }
        const errorType = args.identifyError({
            types: {
                cancelled: 0 /* FACEBOOK_ERROR_TYPES.CANCELLED */,
                unknown: 1 /* FACEBOOK_ERROR_TYPES.UNKNOWN */,
            },
            error,
        });
        if (errorType === 0 /* FACEBOOK_ERROR_TYPES.CANCELLED */) {
            executeProcesses(functionId, callbacks.signInCancelled, 'User cancelled request');
        }
        else {
            executeProcesses(functionId, callbacks.errorProcess, error.toString());
        }
    }
};
exports.default = buildLoginWithFacebook;
